import { HttpInterceptorFn } from '@angular/common/http';

export const timezoneInterceptor: HttpInterceptorFn = (req, next) => {
  // Detect user's timezone from browser (IANA format, e.g., 'America/Los_Angeles')
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  const businessId = req.headers.get('X-Business-ID') || sessionStorage.getItem('businessId') || '';
  const terminalId = req.headers.get('X-Terminal-ID') || sessionStorage.getItem('terminalId') || '';
  const headers: Record<string, string> = {
    'X-User-Timezone': userTimezone
  };

  if (businessId) {
    headers['X-Business-ID'] = businessId;
  }

  if (terminalId) {
    headers['X-Terminal-ID'] = terminalId;
  }

  // Clone the request and add the custom header
  const modifiedReq = req.clone({
    setHeaders: headers
  });

  // Proceed with the modified request
  return next(modifiedReq);
};
